import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function NavigationArrowRightIcon(
  props: IconProps
): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "6"}
      height={height || "10.182"}
      viewBox="0 0 6 10.182"
    >
      <path
        id="Arrow"
        d="M9.264,15.039,12.8,11.5,9.264,7.969a.908.908,0,0,1,1.285-1.285l4.182,4.182a.907.907,0,0,1,0,1.285l-4.182,4.182a.907.907,0,0,1-1.285,0A.927.927,0,0,1,9.264,15.039Z"
        transform="translate(-8.997 -6.417)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
